<template>
    <CCol md="5">
        <CCard class="p-4">
            <CCardBody>
                <CAlert color="primary">
                    {{$t("Check your email for your code verification")}}
                </CAlert>
                <CForm>
                    <img
                        alt="Leadgrease logo"
                        class="mb-4"
                        src="@sset/leadgrease.png"
                    />
                    <h4>{{ $t("reset_password") }}</h4>
                    <CInput
                        type="email"
                        :value.sync="$v.form.email.$model"
                        :isValid="checkIfValid('email')"
                        :placeholder="`${$t('email')}`"
                        autocomplete="email"
                    />
                    <CInput
                        :value.sync="$v.form.code.$model"
                        :isValid="checkIfValid('code')"
                        :placeholder="`${$t('code')}`"
                    />
                    <CInput
                        type="password"
                        :value.sync="$v.form.password.$model"
                        :isValid="checkIfValid('password')"
                        :placeholder="`${$t('password')}`"
                    />
                    <CButton
                        block
                        color="primary"
                        class="px-4"
                        @click="send"
                        :disabled="form._loading"
                    >
                        <CSpinner
                            class="mr-1"
                            color="light"
                            size="sm"
                            v-if="form._loading"
                        />
                        {{ $t("send_password_reset_link") }}
                    </CButton>
                </CForm>
            </CCardBody>
        </CCard>
        <hr />
        <div class="small ml-auto my-auto text-right">
            <router-link :to="{ name: 'login' }" class="">
                {{ $t("go_back") }}
            </router-link>
        </div>
    </CCol>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import pageMixin from "~/mixins/page.js";

export default {
    name: "ConfirmResetPassword",

    layout: "basic",

    middleware: "guest",

    metaInfo() {
        return { title: this.$t("confirm_reset_password") };
    },

    data: () => ({
        form: {
            email: "",
            code: null,
            password: null,
            _loading: false,
        },
    }),

    computed: {
        isValid() {
            return !this.$v.form.$invalid;
        },
    },

    mixins: [validationMixin, pageMixin],

    validations: {
        form: {
            email: {
                required,
                email,
            },
            code: {
                required,
            },
            password: {
                required,
            }
        },
    },

    methods: {
        checkIfValid(fieldName) {
            const field = this.$v.form[fieldName];
            if (!field.$dirty) {
                return null;
            }
            return !(field.$invalid || field.$model === "");
        },

        async send() {
            this.$v.$touch();
            
            try {
                if (this.$v.form.$invalid)
                    throw { code: 422, message: this.$t("invalid_data") };
                this.form._loading = true;
                let form = {...this.form};
                delete form._loading;
                const { data } = await axios.post(
                    "/reset-password",
                    form,
                    {
                        baseURL: "https://auth.leadgrease.com",
                    }
                );
                this.form._loading = false;
                this.$router.push({
                    name: "login",
                    params: { 
                        lang: this.$route.params.lang, 
                        email: this.form.email
                    },
                });

            } catch (error) {
                this.showMessageError(error);
                this.form._loading = false;
            }
        },
    },
    mounted() {
        this.form.email = this.$route.params.email;
    },
};
</script>
